module.exports = __webpack_public_path__ + "img/banner2.c0c39440.jpg";